import { render, staticRenderFns } from "./ScoreRuleDialog.vue?vue&type=template&id=02d4ce5c&scoped=true"
import script from "./ScoreRuleDialog.vue?vue&type=script&lang=js"
export * from "./ScoreRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./ScoreRuleDialog.vue?vue&type=style&index=0&id=02d4ce5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4ce5c",
  null
  
)

export default component.exports